angular.module('component-payments.format.expire.year', [])
	.directive('ctPaymentsFormatExpireYear', paymentsFormatYearDirective);

paymentsFormatYearDirective.$inject = ['CtPayments'];
function paymentsFormatYearDirective (CtPayments) {
	return {
		restrict: 'A',
		require: 'ngModel',
		template: require('./templates/year.html'),
		link: postLink
	};

	function postLink (scope, elem, attr, ctrl) {
		scope.years = CtPayments.years();
	}
}

module.exports = 'component-payments.format.expire.year';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/year.js
 ** module id = 96
 ** module chunks = 1
 **/